export default __webpack_public_path__ + "static/media/search.inline.f5e23bdc.svg";